
import {defineComponent, PropType} from "vue";
import {marked} from "marked";
import {Campaign} from "@/models/campaign";

export default defineComponent({
    name: "ConsentsCheckboxesComponent",
    props: {
        campaign: {
            type: Object as PropType<Campaign>,
            required: true,
        },
        privacyPolicyAccepted: {
            type: Boolean,
            required: true,
        },
        termsAndConditionsConsentGiven: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['termsAndConditionsConsentGivenChanged', 'privacyPolicyAcceptedChanged'],
    methods: {
        termsAndConditionsConsentGivenChanged(event: Event) {
            const target = event.target as HTMLInputElement;
            this.$emit('termsAndConditionsConsentGivenChanged', target.checked);
        },
        privacyPolicyAcceptedChanged(event: Event) {
            const target = event.target as HTMLInputElement;
            this.$emit('privacyPolicyAcceptedChanged', target.checked);
        },
    },
    computed: {
        getTermsUrl(): string {
            if (this.campaign.termsURL) {
                return this.campaign.termsURL;
            }
            return `${this.campaign.contributionURL}?legal=terms`;
        },

        getPrivacyUrl(): string {
            if (this.campaign.privacyURL) {
                return this.campaign.privacyURL;
            }
            return `${this.campaign.contributionURL}?legal=privacy`;
        },

        termsAndConditionsConsentText(): string {
            const originalTermsAndConditionsConsentText = this.campaign.termsAndConditionsConsentText ? this.campaign.termsAndConditionsConsentText : this.$t('creation.transferOfRightsLabel');
            const termsAndConditionsConsentTextWithLink = originalTermsAndConditionsConsentText.replaceAll('##TERMS_LINK##', this.getTermsUrl).replaceAll('##PRIVACY_POLICY_LINK##', this.getPrivacyUrl);

            const markdown = marked.parse(termsAndConditionsConsentTextWithLink, {
                gfm: true,
                breaks: true,
            });
            return markdown.replaceAll('<a', '<a class="link" target="_blank"');
        },

        privacyPolicyText(): string {
            const originalPrivacyPolicyConsentText = this.campaign.privacyPolicyConsentText ?? "";
            const privacyPolicyTextWithLink = originalPrivacyPolicyConsentText.replaceAll('##TERMS_LINK##', this.getTermsUrl).replaceAll('##PRIVACY_POLICY_LINK##', this.getPrivacyUrl);

            const markdown = marked.parse(privacyPolicyTextWithLink, {
                gfm: true,
                breaks: true,
            });
            return markdown.replaceAll('<a', '<a class="link" target="_blank"');
        },
    }
});
